import ItemTag from 'models/tag/ItemTag';

import TagBaseService from 'services/tag/TagBaseService';

export default class ItemTagService extends TagBaseService {
	toModel(tag) {
		return new ItemTag(tag);
	}
}
